import { FormInputWithValidationProps } from '../models/FormInputWithValidation';
import { useFormContext } from 'react-hook-form';
import { useEffect, useRef } from 'react';

export function formInputWithValidation<T>(Component: any) {
  return ({ name, registerOptions, ...rest }: T & FormInputWithValidationProps) => {
    const {
      register,
      formState: { errors },
    } = useFormContext();
    const inputRef = useRef();
    const hasError = !!errors[name];
    const message = (errors[name]?.message as string) || '';
    const { ref, ...regMethods } = register(name, registerOptions);
    useEffect(() => {
      (inputRef.current as HTMLInputElement).setCustomValidity(
        hasError ? `${message} ` : '',
      );
    }, [hasError, message]);

    return (
      <Component
        ref={(e) => {
          ref(e);
          inputRef.current = e;
        }}
        isInvalid={!!errors[name]}
        {...rest}
        {...regMethods}
      />
    );
  };
}
